import SERVICE from '@/constants/services';
export const copyToClipboard = (text) => navigator.clipboard.writeText(text);
export const getPassportUrl = (url, options) => {
    const passportUrl = new URL(url, SERVICE.PASSPORT);
    if (options !== undefined) {
        if (options.withAcceptor) {
            passportUrl.searchParams.set('acceptor', window.location.href);
        }
    }
    return passportUrl.toString();
};
